export enum NotificationTypes {
    Email = 1,
    Text = 2,
    Both = 3,
    None = 4,
}
